import React from 'react';
import { InfoDisplay } from '../../common/InfoDisplay';
import { formatDateTime, convertToPresenceAbsence } from '../../../common/converters';
import { usePrognosis } from '../../hooks/usePrognosis';

type Props = {
  // 搬送先病院ID
  destinationHospitalId?: string | null;
  // 傷病者ID
  patientId?: string | null;
};

/**
 * 予後入力情報コンポーネント
 */
export const PrognosisInfo: React.FC<Props> = ({ 
  destinationHospitalId,
  patientId
}) => {

  const { 
    prognosisInfo, 
    isLoading, 
    isError 
  } = usePrognosis(
    destinationHospitalId,
    patientId
  );

  if (isLoading) {
    return <div>読み込み中...</div>;
  }

  if (isError) {
    return <div>予後入力情報の取得に失敗しました</div>;
  }

  if (!prognosisInfo) {
    return <div>予後入力情報はありません</div>;
  }

  return (
    <div className="p-4 border border-borderGray rounded-md bg-white">
      <h2 className="text-xl font-bold mb-6 text-primary">予後入力情報</h2>
      
      <div className="grid grid-cols-4 gap-6 mb-6">
        <InfoDisplay
          title="確定時診断名"
          content={prognosisInfo.confirmed_diagnosis_name || 'なし'}
        />
        <InfoDisplay
          title="標準病名"
          content={prognosisInfo.standard_disease_name || 'なし'}
        />
        <InfoDisplay
          title="ICDコード"
          content={prognosisInfo.icd_code || 'なし'}
        />
        <InfoDisplay
          title="傷病程度"
          content={prognosisInfo.severity || 'なし'}
        />
      </div>
      
      <div className="grid grid-cols-4 gap-6 mb-6">
        <InfoDisplay
          title="死亡時刻"
          content={formatDateTime(prognosisInfo.death_datetime) || 'なし'}
        />
        <InfoDisplay
          title="二次調査"
          content={typeof prognosisInfo.secondary_survey === 'boolean' 
            ? convertToPresenceAbsence(prognosisInfo.secondary_survey) 
            : prognosisInfo.secondary_survey || 'なし'}
        />
        <div></div>
        <div></div>
      </div>

      <div className="mb-6">
        <InfoDisplay
          title="処置内容"
          content={
            <div className="p-2 bg-white rounded min-h-[100px] whitespace-pre-wrap">
              {prognosisInfo.treatment_content || 'なし'}
            </div>
          }
        />
      </div>

      <div className="mb-6">
        <InfoDisplay
          title="医師コメント欄"
          content={
            <div className="p-2 bg-white rounded min-h-[100px] whitespace-pre-wrap">
              {prognosisInfo.doctor_comment || 'なし'}
            </div>
          }
        />
      </div>

      <InfoDisplay
        title="入力者"
        content={prognosisInfo.input_user || 'なし'}
      />
    </div>
  );
}; 